<script setup lang="ts">
import { onMounted, withDefaults, computed, ref } from 'vue';
import VideoThumbnail from '@/components/videos/VideoThumbnail.vue';
import { useVideos } from '@ilteducation/videos';
import { SearchQuery } from '@ilteducation/content-search';
import { storeToRefs } from 'pinia';

const videoStore = useVideos();
const { searchResults } = storeToRefs(videoStore);
const contextId = ref('');
const videos = computed(() => searchResults.value[contextId.value] ?? []);

const props = withDefaults(
  defineProps<{
    subjectId: string;
  }>(),
  {
    subjectId: () => '',
  },
);
const searchQuery: SearchQuery = {
  filter: { categories: props.subjectId },
  pagination: { size: 4 },
  sort: [{ field: 'createdAt', order: 'desc' }],
};
onMounted(() => {
  contextId.value = videoStore.search(searchQuery);
});
</script>

<template>
  <v-row>
    <VideoThumbnail v-for="(video, index) in videos" :key="index" :video="video" :subject-id="props.subjectId" />
  </v-row>
</template>
